import view from "../../views/aside.js";
import { router } from "../router/index.routes";

let aside = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        
        if(localStorage.getItem("i18nextLng").substring(0,2) == "pt")
        {
            $(".flag-lang").attr("src", "assets/media/flags/br.gif");
        }
        if(localStorage.getItem("i18nextLng").substring(0,2) == "en")
        {
            $(".flag-lang").attr("src", "assets/media/flags/us.gif");
        }
        if(localStorage.getItem("i18nextLng").substring(0,2) == "es")
        {
            $(".flag-lang").attr("src", "assets/media/flags/es.gif");
        }
        if(localStorage.getItem("i18nextLng").substring(0,2) == "zh")
        {
            $(".flag-lang").attr("src", "assets/media/flags/cn.gif");
        }

    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_aside'
};

export default aside;